import React from 'react';
import newWindowIcon from 'assets/images/backoffice/online-store/new-window.svg';
import NotConnected from '../NotConnected/NotConnected';
import styles from './ProductCountColumn.css';

class ProductCountColumn extends React.Component {
  render() {
    const { shop } = this.props;

    if (shop.status !== 'ACTIVE') {
      return <NotConnected />;
    }

    if (shop.item_stats.total_items === 0) {
      return (
        <span className={styles['product-count-text']}>
          <span>0 Product</span>{' '}
          <img src={newWindowIcon} onClick={this._handleProductSync} />
        </span>
      );
    }

    return (
      <span className={styles['product-count-text']}>
        {shop.item_stats.total_live_items + shop.item_stats.total_pending_items}
        {shop.item_stats.total_live_items +
          shop.item_stats.total_pending_items <=
        1
          ? ' Product '
          : ' Products '}
        <span className={styles['text-grey']}>synced</span>{' '}
        <img src={newWindowIcon} onClick={this._handleProductSync} />
      </span>
    );
  }

  _handleProductSync = () => {
    const { shop, onProductSync } = this.props;
    onProductSync(shop);
  };
}

export default ProductCountColumn;
